// extracted by mini-css-extract-plugin
module.exports = {"plp-product-header":"strict-category-listing_plp-product-header__oMh6i"};